import React from "react";
import "../css/Services.css";

const Services = () => {
  const services = [
    {
      title: "PERSONAL TRAINING",
      desc: "1-on-1 customized coaching built around your body, goals, and training level.",
      img: "https://images.pexels.com/photos/2204196/pexels-photo-2204196.jpeg",
    },
    {
      title: "GROUP CLASSES",
      desc: "High-energy fitness classes including HIIT, strength circuits, and endurance training.",
      img: "https://images.pexels.com/photos/3775593/pexels-photo-3775593.jpeg",
    },
    {
      title: "DIET CONSULTATION",
      desc: "Personalized meal planning backed by science and sustainable nutrition strategies.",
      img: "https://images.pexels.com/photos/8844568/pexels-photo-8844568.jpeg",
    },
    {
      title: "YOGA & FLEXIBILITY",
      desc: "Improve balance, breath control, posture, and full-body mobility.",
      img: "https://images.pexels.com/photos/317155/pexels-photo-317155.jpeg",
    },
    {
      title: "HIIT & CONDITIONING",
      desc: "Fat-burning, performance-driven conditioning workouts designed to push limits.",
      img: "https://images.pexels.com/photos/7688863/pexels-photo-7688863.jpeg",
    },
    {
      title: "STRENGTH LAB",
      desc: "Advanced training protocols for strength, powerlifting, and hypertrophy.",
      img: "https://images.pexels.com/photos/949126/pexels-photo-949126.jpeg",
    },
    {
      title: "MOBILITY THERAPY",
      desc: "Recovery-focused sessions including stretching, balance work, and muscle release.",
      img: "https://images.pexels.com/photos/4506217/pexels-photo-4506217.jpeg",
    },
    {
      title: "WEIGHT LOSS PROGRAM",
      desc: "Structured workout plans and nutrition systems built to burn fat effectively.",
      img: "https://images.pexels.com/photos/6455597/pexels-photo-6455597.jpeg",
    }
  ];

  return (
    <div className="services-page">

      {/* ---------------- HERO ---------------- */}
      <section className="services-hero">
        <h1>SERVICES</h1>
        <p>Transform your body — elevate your performance.</p>
        <span className="red-line"></span>
      </section>



      {/* ---------------- SERVICES GRID ---------------- */}
      <section className="services-grid-section">
        <h2 className="section-title">WHAT WE OFFER</h2>

        <div className="services-grid">
          {services.map((service, i) => (
            <div className="service-card" key={i}>
              <img src={service.img} alt={service.title} />

              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
                <span className="link-arrow">→</span>
              </div>
            </div>
          ))}
        </div>
      </section>



      {/* ---------------- SPLIT SECTION 1 ---------------- */}
      <section className="services-split">
        <div className="split-img img1"></div>

        <div className="split-text">
          <h1>BUILT FOR RESULTS.</h1>
          <p>
            Every program at ACE is designed by certified trainers, strength coaches, and 
            performance specialists.  
            Our approach combines science-backed methods with relentless motivation.
          </p>
        </div>
      </section>



      {/* ---------------- SPLIT SECTION 2 ---------------- */}
      {/* <section className="services-split reverse">

        <div className="split-text">
          <h1>TRAIN SMARTER.  
            <br />MOVE BETTER.
          </h1>

          <p>
            Whether it’s fat loss, muscle gain, athletic conditioning, or total body 
            transformation — we tailor your path with precision.
          </p>
        </div>

        <div className="split-img img2"></div>
      </section> */}



      {/* ---------------- CTA ---------------- */}
      <section className="services-cta">
        <h1>LEVEL UP WITH ACE FITNESS.</h1>
        <button>Start Today</button>
      </section>

    </div>
  );
};

export default Services;
